export default class CompanyLocation {
    constructor(longitude, latitude, address) {
      this.longitude = longitude;
      this.latitude = latitude;
      this.address = address;
    }
  
  static fromJson(json) {
    const rawAddress = json.address || "";
    const address = rawAddress.trim();
    return new CompanyLocation(
      json.longitude || 0,
      json.latitude || 0,
      address.length > 0 ? address : "Адрес не указан"
    );
  }
  }